import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { invoiceConstant } from "../constants/constants";


class InvoiceStore extends EventEmitter {

    handleAction(action) {
        switch (action.type) {
            case invoiceConstant.INVOICE_CREATED: {
                const { invoice } = action;
                this.emit(invoiceConstant.INVOICE_CREATED, `Invoice ${invoice.invoiceNumber} created successfully.`);
                break;
            }
            case invoiceConstant.INVOICE_CREATION_FAILED: {
                this.emit(invoiceConstant.INVOICE_CREATION_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const invoiceStore = new InvoiceStore();
dispatcher.register(invoiceStore.handleAction.bind(invoiceStore));
//window.mpdStore = mpdStore;
//window.dispatcher = dispatcher;
export default invoiceStore;


// WEBPACK FOOTER //
// ./src/jsx/store/invoice-store.jsx